import { buildService } from './decorated-service';
import {
  StaticTrustApplication,
  OptionalTrustApplication,
  TrustApplication
} from '../../../core/types/applications/taxable-applications/trust-application';
import {
  handleSubmissionError,
  purgeEmptyFields,
  removeExtraAddressFields,
  submissionTimeOutErrorCode
} from './util';

const TrustSubmissionApi = buildService(
  '/new-account-svc/service/v2/account/trust'
);

export const TrustApplicationService = (
  args: OptionalTrustApplication
): Promise<any> => {
  const validated: StaticTrustApplication = TrustApplication.check(args);
  const submissionPayload = purgeEmptyFields(validated);
  const finalSubmissionPayload = removeExtraAddressFields(submissionPayload);

  return TrustSubmissionApi.add(finalSubmissionPayload, {
    submissionTimeOutErrorCode,
    handleServiceResponse: handleSubmissionError
  });
};
